import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import Swal from "sweetalert2";
import {
  update_premises,
  admin_company_details,
  admin_applications_view,
  admin_domains_list,
  update_premises_superadmin,
} from "../admin.api";
import { useParams } from "react-router-dom";
import BasicDetails from "../common/addCompany/addCompany";
import moment from "moment";
import CommonForm from "../../../components/commonform/commonForm";
import { EmailValidate } from "../../../components/formValidate";
import TextEditer from "../../../components/inputs/texteditor";
import TextField from "../../../components/inputs/textfield";
import jwtDecode from "jwt-decode";
let flag = false;
export default function EditCompanyPremises(props) {
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [basicData, setBasicData] = useState({});
  const [keyvalue, setKeyvalue] = useState(0);
  const [domainData, setDomain] = useState([]);
  const [count, setCount] = useState(1);
  const [companyStatusOptions] = useState([
    { value: "new_company", label: "New Company" },
    { value: "existing_company", label: "Existing Company" },
  ]);
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear + 1}-${startYear + 2}`,
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const monthIndex = moment().month(); // 0-based, Apr=3
  const fyStart = monthIndex >= 3 ? currentYear : currentYear - 1;
  const currentFY = `${fyStart}-${fyStart + 1}`;

  useEffect(() => {
    setBasicData((prev) => ({
      ...prev,
      financial_year:
        prev?.financial_year ||
        (financialYears.includes(currentFY) ? currentFY : "2025-2026"),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const selectedParam = useParams();
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const getPremisesDetails = () => {
    if (!selectedParam?.id) {
      console.error("selectedParam.id is undefined:", selectedParam);
      return;
    }
    admin_applications_view(selectedParam.id)
      .then((res) => {
        if (res?.data) {
          setBasicData(res?.data);
        }
      })
      .catch((err) =>
        console.error(
          "Error fetching Companies in KSPACE Premises details:",
          err,
        ),
      );
  };

  const getDomainTypes = () => {
    setIsActive(true);
    admin_domains_list().then((res) => {
      let domData = res?.data;
      // setDomain(res?.data);
      setCount(count + 1);
      if (domData) {
        getDetails(domData);
      }
      setIsActive(false);
    });
  };
  const handlePhoneNumberChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value.length <= 10) {
      let newValue = value.replace(/[^0-9]/g, "");
      let data = basicData;
      data = {
        ...data,

        [name]: newValue,
      };
      setBasicData(data);
    }
  };

  useEffect(() => {
    // getPremisesDetails();
    getDomainTypes();
  }, [selectedParam]);
  const fileInputRef = useRef(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const maxMB = 1;
    const fileSizeMB = size / (1024 * 1024);

    const isValidType = ["jpg", "jpeg", "png"].includes(type);

    if (!isValidType) {
      showError("File should be in .png / .jpeg / .jpg format");
      resetFileInput();
      return;
    }

    if (fileSizeMB > maxMB) {
      showError("File size is greater than 1MB");
      resetFileInput();
      return;
    }

    setBasicData({
      ...basicData,
      file_name_photo: file.name,
      [e.target.name]: file,
    });
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    setBasicData((prev) => ({
      ...prev,
      file_name_photo: null,
      logo: null,
    }));

    setFileInputKey(Date.now());
  };

  const showError = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };

  const handleNumberChange = (e) => {
    let data = { ...basicData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setBasicData(data);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ask for a remark/message before submitting for acceptance (styled like other popups)
    const { value: remark, isConfirmed } = await Swal.fire({
      title:
        '<span style="font-size:18px; font-weight:600;">Confirm and Submit for Acceptance</span>',
      width: 600,
      html:
        '<div class="form-group mb-2">' +
        '<label class="form-label" style="font-size: 13px; text-align: left; display: block;">Message <span class="text-danger">*</span></label>' +
        '<textarea id="swal-message" class="form-control" placeholder="Enter your message here..." rows="6" style="font-size: 13px; padding: 6px 10px; border: 2px solid #ced4da; resize: vertical; min-height: 160px;"></textarea>' +
        '</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: (el) => {
        // Increase popup height and make content scrollable if needed
        el.style.maxHeight = '80vh';
        el.style.height = 'auto';
        const htmlContainer = el.querySelector('.swal2-html-container');
        if (htmlContainer) {
          htmlContainer.style.maxHeight = '60vh';
          htmlContainer.style.overflowY = 'auto';
        }
      },
      preConfirm: () => {
        const value = (document.getElementById("swal-message").value || "").trim();
        if (!value) {
          Swal.showValidationMessage("Please enter a message");
          return false;
        }
        return value;
      },
    });

    if (!isConfirmed) {
      return; // user cancelled
    }

    const form = new FormData();

    form.append("application_id", basicData?.id ?? null);
    form.append("company_name", basicData?.company_name ?? null);
    form.append("phone_number", basicData?.phone_no);
    form.append("company_type", "international");
    form.append("person_name", basicData?.person_name ?? null);
    form.append("person_designation", basicData?.person_designation ?? null);
    form.append("address", basicData?.address ?? null);
    form.append("email", basicData?.email ?? null);
    form.append("alternate_email", basicData?.alternate_email ?? "");
    form.append("logo", basicData?.logo ?? "");
    form.append("is_admin_created", basicData?.is_admin_created == false ?? "");
    form.append(
      "country_code",
      basicData?.alternate_phone ? basicData?.country_code : "",
    );
    form.append("alternate_phone", basicData?.alternate_phone ?? "");
    form.append("company_status", basicData?.company_status ?? "");

    // Set application status to Submitted when confirming and submitting
    form.append("application_status", 1); // 1 = Submitted

    // Attach the remark/message from the popup using admin_message key
    form.append("admin_message", remark.trim());

    // Append financial_records only when an entry actually has data
    if (
      Array.isArray(basicData.financial_records) &&
      basicData.financial_records.length > 0
    ) {
      basicData.financial_records.forEach((record, index) => {
        const hasYear = (record.financial_year || "").toString().trim() !== "";
        const hasTurnover =
          record.fy_turnover !== null &&
          record.fy_turnover !== undefined &&
          record.fy_turnover !== "";
        const hasRemarks = (record.remarks || "").toString().trim() !== "";

        // Skip placeholder/empty rows
        if (!hasYear && !hasTurnover && !hasRemarks) {
          return;
        }

        form.append(
          `financial_records[${index}][financial_year]`,
          record.financial_year ?? "",
        );
        form.append(
          `financial_records[${index}][fy_turnover]`,
          record.fy_turnover ?? "",
        );
        form.append(
          `financial_records[${index}][remarks]`,
          record.remarks ?? "",
        );
      });
    }
    form.append(
      "abstract_project_proposal",
      basicData?.abstract_project_proposal ?? null,
    );
    form.append("upload_proposal", basicData?.upload_proposal ?? "");
    form.append("capital_investment", basicData?.capital_investment ?? null);
    form.append("ex_man_power", basicData?.ex_man_power ?? null);
    form.append("site_link", basicData?.site_link ?? null);

    form.append(
      "any_other_flag",
      basicData?.any_other_flag == true ? "1" : "0",
    );
    form.append(
      "any_other_domain",
      basicData?.any_other_flag == true ? basicData?.any_other_domain : "",
    );
    form.append("file_name", basicData?.file_name ?? "");
    if (basicData?.id) form.append("application_id", basicData?.id);
    basicData?.product_profiles.forEach((item, index) => {
      form.append(
        `product_profiles[${index}][product_name]`,
        item.product_name,
      );
      form.append(
        `product_profiles[${index}][product_desc]`,
        item.product_desc,
      );
    });
    domainData.forEach((item, index) => {
      if (item.checked) {
        form.append(`domain_types[${index}][domain_name]`, item.domain_name);
        form.append(`domain_types[${index}][id]`, item.id);
      }
    });
    form.append("area_type", basicData?.area_type ?? null);

    setIsActive(true);
    (adminType === 1 ? update_premises(form) : update_premises_superadmin(form))

      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      setActiveStep(0);
      setBasicData({});

      setDomain([]);
      props.history.push(
        `/company-request-list/${basicData?.area_type === "own_land" ? "own" : "kspace"
        }`,
      );
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setBasicData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const getDetails = (domData) => {
    let otherDom = [];
    admin_applications_view(selectedParam?.id).then((res) => {
      let Data = res?.data;
      otherDom = Data?.domain_types?.filter(
        (ar1) => !domData.some((ar2) => ar1?.domain_name === ar2?.domain_name),
      );

      domData?.forEach((item) => {
        item["checked"] = Data?.domain_types?.some(
          (dom) => item?.domain_name === dom?.domain_name,
        );
      });

      setDomain(domData);
      let d = {
        ...Data,
        // Normalize any_other flags/domains from API
        any_other_flag:
          Data.any_other_flag && Data.any_other_flag !== "0" ? true : false,
        any_other_domain:
          Data.any_other_domain && Data.any_other_flag !== "0"
            ? Data.any_other_domain
            : "",
        // Normalize country code
        country_code:
          Data.country_code === "null" || Data.country_code === "undefined"
            ? ""
            : Data.country_code,
        // Prefill financial_records; if none, add an empty row as fallback
        financial_records:
          Array.isArray(Data?.financial_records) &&
            Data.financial_records.length > 0
            ? Data.financial_records
            : [{ financial_year: "", fy_turnover: "", remarks: "" }],
        // If API sent financial_records, treat as existing company so the section is visible
        company_status:
          Array.isArray(Data?.financial_records) &&
            Data.financial_records.length > 0
            ? "existing_company"
            : Data.company_status,
      };
      setBasicData((prevData) => ({
        ...prevData,
        ...d,
        mobile_number: Data.phone_no,
        file_name: Data?.upload_proposal,
        product_profiles: Data?.product_profiles,
      }));
      setCount(count + 1);
    });
    setIsActive(false);
  };

  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = basicData;
    data[name] = value;
    setBasicData(data);
    setKeyvalue(keyvalue + 1);
  };
  const addNewProductProfile = (i) => {
    let data = { ...basicData };

    data.product_profiles.push({ product_name: "", product_desc: "" });
    setBasicData(data);
    setCount(count + 1);
  };
  const RemoveProduct = (i) => {
    let data = { ...basicData };
    data.product_profiles.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleMultiChange = (e, i) => {
    let data = { ...basicData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],
      [e.target.name]: e.target.value,
    };

    setBasicData(data);
    setCount(count + 1);
  };
  const handleProductDesc = (val, i) => {
    let data = { ...basicData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],

      product_desc: val,
    };

    setBasicData(data);
    setCount(count + 1);
  };

  const handleCheckChange = (e, item) => {
    flag = false;
    let data = [...domainData];

    data[item]["checked"] = e.target.checked;
    if (domainData) {
      domainData.forEach((item) => {
        if (item.checked) flag = true;
      });
    }
    setCount(count + 1);
    setDomain(data);
  };
  const handleValid = () => {
    let flags = false;
    if (domainData) {
      domainData.forEach((item) => {
        if (item.checked) flags = true;
      });
    }
    return flags;
  };

  const handleOtherChange = (e) => {
    setBasicData({ ...basicData, [e.target.name]: e.target.checked });
  };

  const addFinancialRecord = () => {
    setBasicData((prev) => {
      const list = Array.isArray(prev.financial_records)
        ? prev.financial_records
        : [];
      if (list.length >= 3) {
        showError("Maximum 3 financial records allowed");
        return prev;
      }
      return {
        ...prev,
        financial_records: [
          ...list,
          { financial_year: "", fy_turnover: "", remarks: "" },
        ],
      };
    });
  };

  const removeFinancialRecord = (idx) => {
    setBasicData((prev) => ({
      ...prev,
      financial_records: (prev.financial_records || []).filter(
        (_, i) => i !== idx,
      ),
    }));
  };

  const handleFinancialRecordChange = (idx, field, value) => {
    let sanitizedValue = value;
    if (field === "fy_turnover") {
      sanitizedValue = value.replace(/[^0-9.]/g, "");
      const parts = sanitizedValue.split(".");
      if (parts.length > 2) {
        sanitizedValue = parts[0] + "." + parts.slice(1).join("");
      }
      if (sanitizedValue.length > 13) {
        sanitizedValue = sanitizedValue.slice(0, 13);
      }
    }
    setBasicData((prev) => ({
      ...prev,
      financial_records: (prev.financial_records || []).map((rec, i) =>
        i === idx ? { ...rec, [field]: sanitizedValue } : rec,
      ),
    }));
  };
  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "pdf" ||
      type?.toLowerCase() === "doc" ||
      type?.toLowerCase() === "docx"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        setBasicData({
          ...basicData,
          file_name: e.target.files[0].name,
          [e.target.name]: e.target.files[0],
        });

        // handlefile();
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setBasicData({
          ...basicData,
          file_name: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .doc / .docx / .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      setBasicData({
        ...basicData,
        file_name: null,
        [e.target.name]: null,
      });
    }
  };

  return (
    <>
      <Loader open={isActive} />
      <div className="add-per">
        <div className="view-container">
          <form onSubmit={handleSubmit}>
            <h6>
              <b>Update Companies</b>
            </h6>
            <hr />
            <div className="row">
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Company Name"
                  required
                  // disabled
                  name="company_name"
                  value={basicData?.company_name ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Contact Person Name"
                  required
                  disabled
                  name="person_name"
                  value={basicData?.person_name ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Contact Person Designation"
                  required
                  // disabled
                  name="person_designation"
                  value={basicData?.person_designation ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="multiline"
                  label="Address"
                  required
                  name="address"
                  value={basicData?.address ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="email"
                  label="Email ID"
                  error={error.email}
                  required
                  disabled
                  name="email"
                  value={basicData?.email ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Website Link"
                  error={error.site_link}
                  // disabled
                  name="site_link"
                  value={basicData?.site_link ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Mobile No."
                  maxLength="10"
                  minLength="10"
                  disabled
                  pattern="[0-9]{10}"
                  value={basicData?.phone_no}
                  required
                  onChange={(e) => {
                    handlePhoneNumberChange(e);
                  }}
                  name="phone_no"
                  {...props}
                />
              </div>
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="text"
                  label="Alternate Phone"
                  maxLength="10"
                  minLength="10"
                  // disabled
                  pattern="[0-9]{10}"
                  value={basicData?.alternate_phone}
                  onChange={(e) => {
                    handlePhoneNumberChange(e);
                  }}
                  name="alternate_phone"
                  {...props}
                />
              </div>
              <div className="col-8 mb-2">
                <label className="control-label mylabel mb-2">
                  New company / Existing company ?
                </label>
                <select
                  className="form-select mandatory-select"
                  aria-label="Select Company Status"
                  required
                  name="company_status"
                  value={basicData?.company_status ?? ""}
                  onChange={(e) => handleChange(e)}
                >
                  <option value="">Select Company Status</option>
                  {companyStatusOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              {basicData?.company_status === "existing_company" && (
                <div className="col-8 mb-2">
                  <label className="control-label mylabel mb-2">
                    Financial Records
                  </label>
                  {(basicData.financial_records || []).map((rec, idx) => {
                    const selectedYears = (basicData.financial_records || [])
                      .map((r) => r.financial_year)
                      .filter((y) => y);
                    const availableYears = financialYears.filter(
                      (y) =>
                        !selectedYears.includes(y) || selectedYears[idx] === y,
                    );
                    return (
                      <div
                        key={`fr-${idx}`}
                        className="section-datas-cont mb-3"
                      >
                        <div className="row">
                          <div className="col-6">
                            <label className="control-label mylabel mb-2">
                              Financial Year
                            </label>
                            <select
                              className="form-select mandatory-select mb-2"
                              aria-label="Select Financial Year"
                              required
                              value={rec.financial_year || ""}
                              onChange={(e) =>
                                handleFinancialRecordChange(
                                  idx,
                                  "financial_year",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">Select Financial Year</option>
                              {availableYears.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-6">
                            <CommonForm
                              fieldType="text"
                              label="Turnover (in Crores)"
                              value={rec.fy_turnover || ""}
                              onChange={(e) =>
                                handleFinancialRecordChange(
                                  idx,
                                  "fy_turnover",
                                  e.target.value,
                                )
                              }
                              {...props}
                              required
                            />
                          </div>
                        </div>
                        {(basicData.financial_records || []).length > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm mt-2"
                            onClick={() => removeFinancialRecord(idx)}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    );
                  })}
                  {(basicData.financial_records || []).length < 3 && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm mt-2"
                      onClick={addFinancialRecord}
                    >
                      Add Previous
                    </button>
                  )}
                </div>
              )}
              <div className="col-8 mb-2">
                <CommonForm
                  fieldType="email"
                  label="Alternative Email"
                  error={error.alternate_email}
                  // disabled
                  name="alternate_email"
                  value={
                    basicData?.alternate_email &&
                      basicData?.alternate_email !== "null"
                      ? basicData?.alternate_email
                      : ""
                  }
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>

              <div className="col-8 mb-2 mt-2">
                <CommonForm
                  fieldType="multiline"
                  label="Abstract Project Proposal"
                  required
                  name="abstract_project_proposal"
                  // disabled
                  value={basicData?.abstract_project_proposal ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>
            </div>
            <div className="col-8">
              <CommonForm
                key={fileInputKey}
                ref={fileInputRef}
                fieldType="file"
                name="logo"
                {...props}
                label="Logo"
                id="logo"
                fileName={
                  basicData?.file_name_photo
                    ? basicData?.file_name_photo
                    : basicData?.logo
                }
                accept=".jpg,.jpeg,.png"
                type="file"
                variant="outlined"
                onChange={handlePhotoFileChange}
              />
              <small className="pers">
                *Upload only .jpg , .jpeg , .png format and Size should be less
                than 1MB
              </small>
            </div>
            <div className="col-8 mb-2">
              <div>
                {basicData?.product_profiles?.map((e, i) => (
                  <div className="section-datas-cont" key={i}>
                    <div className="header-label">Product Profile</div>
                    <div className="section-Cont">
                      <CommonForm
                        fieldType="text"
                        label="Product Name"
                        required
                        // disabled
                        name="product_name"
                        value={e?.product_name}
                        onChange={(e) => {
                          handleMultiChange(e, i);
                        }}
                        {...props}
                      />
                      <TextEditer
                        label="Product Description (Required)"
                        required
                        name="product_desc"
                        // disabled={true}
                        value={e?.product_desc}
                        keyValue={i}
                        {...props}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-8 mb-2">
              <div>
                <div className="header-label">Domain Type</div>
                <div className="check-box-cont">
                  {domainData &&
                    domainData?.map((item, index) => (
                      <CommonForm
                        fieldType="checkbox"
                        value={item.checked}
                        // disabled
                        required={!basicData?.any_other_flag && !handleValid()}
                        checked={item.checked}
                        onChange={(e) => handleCheckChange(e, index)}
                        label={item.domain_name}
                        {...props}
                      />
                    ))}
                  <CommonForm
                    fieldType="checkbox"
                    onChange={handleOtherChange}
                    label="Any Other"
                    // disabled
                    name="any_other_flag"
                    checked={basicData?.any_other_flag}
                    value={basicData?.any_other_flag}
                    {...props}
                  />
                </div>
                {basicData?.any_other_flag &&
                  basicData?.any_other_flag !== "0" && (
                    <div>
                      <CommonForm
                        fieldType="text"
                        placeholder="Please specify the Domain.."
                        required
                        // disabled
                        name="any_other_domain"
                        value={basicData?.any_other_domain ?? ""}
                        onChange={(e) => {
                          textFieldChange(e);
                        }}
                        {...props}
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="col-8 mb-2">
              <div>
                <CommonForm
                  fieldType="file"
                  required={!basicData?.file_name ? true : false}
                  name="upload_proposal"
                  {...props}
                  label="Upload Project Proposal"
                  id="upload_proposal"
                  fileName={basicData?.file_name}
                  // disabled
                  accept=".pdf,.docx,.doc"
                  type="file"
                  variant="outlined"
                  onChange={handleFileChange}
                />
                <div className="file-up-helper">
                  *Upload only .pdf , .doc, .docx and Size should be less than
                  5MB
                </div>
              </div>
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="number"
                label="Capital investment so far in lakhs"
                required
                name="capital_investment"
                value={basicData?.capital_investment ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>
            <div className="col-8 mb-2">
              <CommonForm
                fieldType="number"
                label=" Expected Direct employment as on Date"
                required
                name="ex_man_power"
                value={basicData?.ex_man_power ?? ""}
                onChange={(e) => {
                  textFieldChange(e);
                }}
                {...props}
              />
            </div>

            <div className="">
              <div className="col-8 mb-2">
                <center>
                  <button type="submit" className="primary-btn basic-submit">
                    Confirm and Submit for acceptance
                  </button>
                </center>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </>
  );
}
